module.exports = __webpack_public_path__ + "img/swap_vert_2.82a731e1.svg";